export const ENABLE = false
export const NOT_ENABLE = true

export const state_map = {
    [ENABLE]: '启用',
    [NOT_ENABLE]: '未启用'
}

export const stateTransToLabel = key => state_map[key]

export const state_options = [
    {
        label: stateTransToLabel(ENABLE),
        value: ENABLE
    },
    {
        label: stateTransToLabel(NOT_ENABLE),
        value: NOT_ENABLE
    }
]

export const OPERATION = 'YY'
export const BUSINESS = 'BD'

export const jobs_map = {
    [OPERATION]: '运营',
    [BUSINESS]: 'BD'
}

export const jobsTransToLabel = key => jobs_map[key]

export const jobs_options = [
    {
        label: jobsTransToLabel(OPERATION),
        value: OPERATION
    },
    {
        label: jobsTransToLabel(BUSINESS),
        value: BUSINESS
    }
]
